export const HOME = "/";
export const CLIENTS = "clients";
export const SIGN_IN = "signIn";
export const MANAGE_PLATFORM = "manage-platforms";
export const CLIENT_CONFIGURATION = "clients-platforms";
export const FILE_LIST = "file-list";
export const REDIRECT = "users/login";
export const ERROR_PAGE = "error-page";
export const NOT_AUTHORIZED = "not-authorized";
export const CREDENTIAL_CONFIGURATION = "credentials-configurations";

export const USER_ROLES = "USER ROLES";
export const AUTH_TOKEN = "AUTH_TOKEN";

export const COPY_RIGHT_TEXT = "© 2025 2060 Digital. All Rights Reserved.";

export const CLIENTS_TABLE_PLACEHOLDER = "Client Name, etc...";
export const CLIENTS_TABLE_STORAGE_KEY = "Clients-Table";
export const CLIENTS_SCREEN_LABEL = "OUR CLIENTS";

export const CLIENTS_CONFIG_TABLE_PLACEHOLDER = "Client Name, etc...";
export const CLIENTS_CONFIG_TABLE_STORAGE_KEY = "Clients-Config-Table";
export const CLIENTS_CONFIG_SCREEN_LABEL = "CLIENT PLATFORMS";

export const FILE_LIST_TABLE_PLACEHOLDER = "File Name, etc...";
export const FILE_LIST_TABLE_STORAGE_KEY = "FileList-Table";
export const FILE_LIST_SCREEN_LABEL = "FILE LIST";

export const CLIENT_STATUS: any = {
  active: "Active",
  pending_mapping: "Pending Assignment",
  hold: "Hold",
  terminated: "Terminated",
};

export const FileListDataColumns = [];

export const FileListColumns = [];

export const ClientsDataColumns = [
  {
    value: "clientName",
    label: "Client Name",

    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "id",
    label: "ID",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: false,
  },
  
  {
    value: "clientStatus",
    label: "Client Status",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "advisrId",
    label: "Advisr Id",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "tapClicksId",
    label: "TapClicks Id",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "industry",
    label: "Industry(s)",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "market",
    label: "Market(s)",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "parentAccountDetails",
    label: "Parent Account",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "agencyName",
    label: "Agency Name",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "createdDate",
    label: "Created Date",
    numeric: false,
    date: true,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "lastUpdatedDate",
    label: "Last Updated Date",
    numeric: false,
    date: true,
    showFilter: true,
    showColumn: true,
  },
];

export const ClientsConfigDataColumns = [
  {
    value: "clientStatus",
    label: "Client Status",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "clientName",
    label: "Client Name",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "dataSourceName",
    label: "Data Source",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },{
    value: "connection",
    label: "Connection",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "platformId",
    label: "Account Id",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "status",
    label: "Data Source Status",
    numeric: false,
    date: false,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "createdDate",
    label: "Created Date",
    numeric: false,
    date: true,
    showFilter: true,
    showColumn: true,
  },
  {
    value: "lastUpdatedDate",
    label: "Last Updated",
    numeric: false,
    date: true,
    showFilter: true,
    showColumn: true,
  }
];

export const ClientsConfigSampleData = [
  {
    clientStatus: "active",
    clientName: "Sample Client",
    createdDate: "2025-01-28T15:47:34.9433333",
    lastUpdatedDate: "2025-01-28T15:47:34.9433333",
    adAccount: "Test",
    adPlatform: "Google",
    platformStatus: "active",
    dataSource:"Search Account",
    id: 1,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Client Name",
    createdDate: "2025-02-28T15:47:34.9433333",
    lastUpdatedDate: "2025-02-28T15:47:34.9433333",
    adAccount: "Test 2",
    adPlatform: "Google",
    
    dataSource:"Search Account",
    
    platformStatus: "active",
    id: 2,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Dummy Client",
    createdDate: "2025-04-28T15:47:34.9433333",
    lastUpdatedDate: "2025-04-28T15:47:34.9433333",
    adAccount: "Test 3",
    adPlatform: "Google",
    platformStatus: "In-active",
    dataSource:"Search Account",
    id: 4,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Ordinary Client",
    createdDate: "2025-04-28T15:47:34.9433333",
    lastUpdatedDate: "2025-04-28T15:47:34.9433333",
    adAccount: "New Test",
    adPlatform: "Facebook",
    platformStatus: "In-active",
    dataSource:"Search Account",
    id: 5,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Secoundary Client",
    createdDate: "2025-05-28T15:47:34.9433333",
    lastUpdatedDate: "2025-05-28T15:47:34.9433333",
    adAccount: "New Test 2",
    adPlatform: "Facebook",
    dataSource:"Search Account",
    platformStatus: "active",
    id: 6,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Important Client",
    createdDate: "2025-07-28T15:47:34.9433333",
    lastUpdatedDate: "2025-07-28T15:47:34.9433333",
    adAccount: "New Test 3",
    adPlatform: "Facebook",
    platformStatus: "active",
    dataSource:"Search Account",
    id: 7,
    deleteFlag: false,
  },
  {
    clientStatus: "active",
    clientName: "Sample Client",
    createdDate: "2025-01-28T15:47:34.9433333",
    lastUpdatedDate: "2025-01-28T15:47:34.9433333",
    adAccount: "New Test 4",
    adPlatform: "Linkedin",
    platformStatus: "In-active",
    dataSource:"Search Account",
    id: 8,
    deleteFlag: false,
  },
];

export const ALLOWED_ROLES: any = ["Admin", "Administrator"];

export const ALL_ROLES: any = [
  "Admin",
  "Administrator",
  "Internal User",
  "External User",
];

export const getUserRoles = () => {
  let roles: any = window.localStorage.getItem(USER_ROLES);
  roles = JSON.parse(roles) || [];
  return roles;
};

export const getAuthToken = () => {
  let authToken = window.localStorage.getItem(AUTH_TOKEN) || "";
  const hasAuthToken = authToken ? true : false;
  return hasAuthToken;
};

export const getRefreshToken = () => {
  return window.localStorage.getItem("REFRESH_TOKEN") || "";
};

export const getFormattedDataTime = (date: any) => {
  const selectedDate = new Date(date); // Replace this with your date object
  const formattedDate = selectedDate
    .toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).replace(/(\d{2})\/(\d{2})\/(\d{2}), (\d{2}:\d{2})/, '$1/$2/$3 - $4');
    
  return formattedDate;
};

export const downloadFile = (fileUrl : any, fileName : any) => {
  // Create an anchor element
  const link = document.createElement('a');
  
  // Set the href attribute to the file URL
  link.href = fileUrl;
  
  // Set the download attribute to the desired file name
  link.download = fileName || 'downloadedFile.pdf'; // Default name if not provided
  
  // Append the anchor element to the body (required for Firefox)
  document.body.appendChild(link);
  
  // Trigger the download by simulating a click
  link.click();
  
  // Remove the anchor element from the document
  document.body.removeChild(link);
}

export type AllowedFileType = 
  | 'application/pdf'
  | 'application/msword'
  | 'application/vnd.ms-excel'
  | 'application/vnd.ms-powerpoint'
  | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  | 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  | 'text/csv'
  | 'image/jpeg'
  | 'image/png'
  | 'image/gif';


  export const allowedExtensions = {
    document: ['.txt', '.doc', '.docx', '.pdf', '.rtf', '.odt', '.html', '.md', '.docm', '.dotx', '.dotm'],
    spreadsheet: ['.xls', '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm', '.ods', '.csv','.xla', '.xlam', '.xml'],
    presentation: ['.ppt', '.pptx', '.pptm', '.potx', '.potm', '.ppsx', '.ppsm', '.odp'],
    image: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.svg', '.webp'],
    audio: ['.mp3', '.wav', '.ogg', '.flac', '.aac'],
    video: ['.mp4', '.avi', '.mov', '.mkv', '.webm', '.flv', 'video/avi'],
    archive: ['.zip', '.rar', '.tar', '.7z', '.gz'],
    database: ['.sql', '.db', '.sqlite'],
    other: ['.json', '.csv']
  };

  // Define MIME types for common file extensions
  export const extensionToMimeType: Record<string, string> = {
    // Document files
    '.txt': 'text/plain',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.docm': 'application/vnd.ms-word.document.macroEnabled.12',
    '.dotx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    '.dotm': 'application/vnd.ms-word.template.macroEnabled.12',
    '.pdf': 'application/pdf',
    '.rtf': 'application/rtf',
    '.odt': 'application/vnd.oasis.opendocument.text',
    '.html': 'text/html',
    '.md': 'text/markdown',
    
    // Spreadsheet files
    '.xls': 'application/vnd.ms-excel',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
    '.xlsb': 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    '.xltx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    '.xltm': 'application/vnd.ms-excel.template.macroEnabled.12',
    '.ods': 'application/vnd.oasis.opendocument.spreadsheet',
    '.csv': 'text/csv',

    '.xml': 'text/xml',
    '.xlam': 'application/vnd.ms-excel.addin.macroEnabled.12',
    '.xla' : 'application/vnd.ms-excel',

    
    // Presentation files
    '.ppt': 'application/vnd.ms-powerpoint',
    '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    '.pptm': 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    '.potx': 'application/vnd.openxmlformats-officedocument.presentationml.template',
    '.potm': 'application/vnd.ms-powerpoint.template.macroEnabled.12',
    '.ppsx': 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    '.ppsm': 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    '.odp': 'application/vnd.oasis.opendocument.presentation',
    
    // Image files
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
    '.gif': 'image/gif',
    '.bmp': 'image/bmp',
    '.tiff': 'image/tiff',
    '.svg': 'image/svg+xml',
    '.webp': 'image/webp',
    
    // Audio files
    '.mp3': 'audio/mpeg',
    '.wav': 'audio/wav',
    '.ogg': 'audio/ogg',
    '.flac': 'audio/flac',
    '.aac': 'audio/vnd.dlna.adts',
    
    // Video files
    '.mp4': 'video/mp4',
    '.mov': 'video/quicktime',
    '.mkv': 'video/x-matroska',
    '.webm': 'video/webm',
    '.flv': 'video/x-flv',
    '.avi': 'video/avi',
    
    // Archive files
    '.zip': 'application/zip',
    '.tar': 'application/x-tar',
    '.7z': 'application/x-compressed',
    '.gz': 'application/gzip',
    '.rar': 'application/x-compressed',
    
    // Database files
    '.sql': 'application/sql',
    '.db': 'application/x-sqlite3',
    '.sqlite': 'application/x-sqlite3',
    
    // Other files
    '.json': 'application/json'
  };

  

 // Allowed file types
 export const allowedTypes: AllowedFileType[] = [
  'application/pdf', 
  'application/msword', 
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/csv',
  'image/jpeg',
  'image/png',
  'image/gif'
];

// Forbidden file extensions (executable, batch files, etc.)
export const forbiddenExtensions: string[] = ['.exe', '.bat', '.cmd', '.sh', '.com', '.vbs', '.js'];

// Maximum file size in MB
export const MAX_FILE_SIZE: number = 25;
